/**
 * The decryption gate.
 *
 * This is the layer that makes "unreadable the moment it expires" true on a web
 * client that cannot run in the background. Nothing else can render a photo, so
 * refusing here is the guarantee — the file being erased afterwards is cleanup.
 */

import type { TrustedClock } from './time.ts';

export type GateResult =
  | { allowed: true }
  | { allowed: false; reason: 'expired' | 'clock-tampered' };

export function mayDecrypt(expiresAt: number | null, clock: TrustedClock): GateResult {
  // A backwards clock is refused outright: we cannot tell what has expired.
  if (clock.tampered) return { allowed: false, reason: 'clock-tampered' };
  if (expiresAt === null) return { allowed: true };
  if (clock.now() >= expiresAt) return { allowed: false, reason: 'expired' };
  return { allowed: true };
}
